class SubscribePopup extends HTMLElement {
  constructor() {
    super();
    this.popupSection = this.closest('.section-subscribe-popup');
    this.popupWrapp = this.closest('.popup-wrapp');
    this.closeButton = this.querySelector('.subscribe-close-popup');
    this.form = this.querySelector('#subscribe-block-form');
    this.inputField = this.querySelector('.subscribe-block-form__field-wrapper .field__input');
    this.overlay = document.querySelector('.subscribe-block-overlay');
    this.maxShowTimes = parseInt(this.getAttribute('data-show-subscribe'), 10) || 0;
    this.closeCount = Number(sessionStorage.getItem('subsribePopupCloseCount')) || 0;
    this.formSubmitted = localStorage.getItem('subsribeFormSubmitted') === 'true';
    this.popupShown = false;
    this.isInitialized = false;
    this.isDesignMode = window.Shopify && window.Shopify.designMode === true;

    this.previouslyFocusedElement = null;

    this.scrolledMoreThanDistance = false;
    this.pageLoadedMoreThanTime = false;

    this.pageLoadTimer = null;
    this.showTimer = null;

    this.POPUP_DELAY = 16000;
    this.POPUP_DELAY_SCROLL = 10;

    this.bindMethods();
    this.init();
  }

  bindMethods() {
    this.handleScroll = this.checkScroll.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleCloseClick = () => this.hidePopup();
    this.handleOverlayClick = () => this.hidePopup();
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handlePageLoadTime = this.onPageLoadedTime.bind(this);
  }

  init() {
    if (
      !this.popupSection ||
      this.closeCount >= this.maxShowTimes ||
      this.formSubmitted ||
      this.isInitialized
    ) {
      return;
    }

    this.setupEventListeners();
    this.handleScrollTrigger();
    this.pageLoadTimer = setTimeout(this.handlePageLoadTime, this.POPUP_DELAY);
    this.isInitialized = true;
  }

  setupEventListeners() {
    this.closeButton?.addEventListener('click', this.handleCloseClick);
    this.overlay?.addEventListener('click', this.handleOverlayClick);
    document.addEventListener('keydown', this.handleKeydown);
    this.form?.addEventListener('submit', this.handleFormSubmit);
  }

  handleKeydown(event) {
    const isEscape = event.key === 'Escape' || event.key === 'Esc';
    if (!isEscape) return;
    if (this.popupSection?.classList.contains('popup-visible')) this.hidePopup(true);
  }

  handleFormSubmit() {
    localStorage.setItem('subsribeFormSubmitted', 'true');
    this.formSubmitted = true;
  }

  showPopup() {
    if (this.popupShown) return;

    this.previouslyFocusedElement =
      document.activeElement instanceof HTMLElement ? document.activeElement : null;

    this.popupSection.classList.remove('popup-hidden');
    this.popupSection.classList.add('popup-visible');
    if (!this.isDesignMode) this.popupWrapp?.removeAttribute('inert');
    this.popupShown = true;

    setTimeout(() => {
      const initialFocus = this.inputField || this.closeButton || this.popupSection;
      if (typeof trapFocus === 'function') {
        trapFocus(this.popupSection, initialFocus);
      } else if (initialFocus) {
        initialFocus.focus();
      }
    }, 100);
  }

  hidePopup(fromKeyboard = false) {
    if (!this.popupSection) return;

    this.popupSection.classList.remove('popup-visible');
    this.popupSection.classList.add('popup-hidden');
    if (!this.isDesignMode) this.popupWrapp?.setAttribute('inert', '');

    this.closeCount++;
    sessionStorage.setItem('subsribePopupCloseCount', this.closeCount);

    const elementToFocus =
      fromKeyboard && this.previouslyFocusedElement && document.contains(this.previouslyFocusedElement)
        ? this.previouslyFocusedElement
        : null;

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(elementToFocus || null);
    } else if (elementToFocus && typeof elementToFocus.focus === 'function') {
      setTimeout(() => {
        if (document.contains(elementToFocus)) {
          elementToFocus.focus();
        }
      }, 100);
    }

    this.previouslyFocusedElement = null;
  }

  checkScroll() {
    const scrolledPercentage =
      ((window.scrollY + window.innerHeight) / document.documentElement.scrollHeight) * 100;

    if (scrolledPercentage > this.POPUP_DELAY_SCROLL) {
      this.scrolledMoreThanDistance = true;
      this.removeScrollListener();

      if (this.pageLoadedMoreThanTime) {
        this.showPopup();
      } else {
        this.showTimer = setTimeout(() => this.showPopup(), this.POPUP_DELAY);
      }
    }
  }

  onPageLoadedTime() {
    this.pageLoadedMoreThanTime = true;
    if (this.scrolledMoreThanDistance) this.showPopup();
  }

  handleScrollTrigger() {
    const initialScrolledPercentage =
      ((window.scrollY + window.innerHeight) / document.documentElement.scrollHeight) * 100;

    if (initialScrolledPercentage > this.POPUP_DELAY_SCROLL) {
      this.scrolledMoreThanDistance = true;
      if (!this.pageLoadedMoreThanTime) {
        this.showTimer = setTimeout(() => this.showPopup(), this.POPUP_DELAY);
      }
    } else {
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }
  }

  removeScrollListener() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  disconnectedCallback() {
    this.cleanup();
  }

  cleanup() {
    this.closeButton?.removeEventListener('click', this.handleCloseClick);
    this.overlay?.removeEventListener('click', this.handleOverlayClick);
    document.removeEventListener('keydown', this.handleKeydown);
    this.form?.removeEventListener('submit', this.handleFormSubmit);
    this.removeScrollListener();
    clearTimeout(this.pageLoadTimer);
    clearTimeout(this.showTimer);
    this.isInitialized = false;
  }
}

customElements.define('subscribe-popup', SubscribePopup);